var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.promptInject ? 'shifted' : ''],attrs:{"id":"notification"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.notification)?_c('div',{class:['notification-inner', _vm.centered ? 'centered': '']},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.notification))])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }